/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Focus_TiInputs */

const en_funnel_ob_ben_focus_ti = /** @type {(inputs: Funnel_Ob_Ben_Focus_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow along, and it sticks.`)
};

const es_funnel_ob_ben_focus_ti = /** @type {(inputs: Funnel_Ob_Ben_Focus_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue el texto, y se te queda.`)
};

/**
* | output |
* | --- |
* | "Follow along, and it sticks." |
*
* @param {Funnel_Ob_Ben_Focus_TiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_focus_ti = /** @type {((inputs?: Funnel_Ob_Ben_Focus_TiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Focus_TiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_focus_ti(inputs)
	return en_funnel_ob_ben_focus_ti(inputs)
});